import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { Attribute } from "@/types/attribute";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Get a value from an object by a given path (dot notation)
 * @param obj - The object to get the value from
 * @param path - The path to the value (do  t notation)
 */
export function getValueByPath(obj: any, path: string) {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
}

export function promiseSleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Used when we want to curcumvent the routing engine and just visually change a search param
 * @param key
 * @param value
 */
export const addSearchParamToHistory = (key: string, value: string | undefined) => {
    const url = new URL(window.location.href);
    if (value) {
        url.searchParams.set(key, value);
    } else {
        url.searchParams.delete(key);
    }
    window.history.pushState(null, "", url.toString());
};

/** There once was a bug that causes the preferences to nu undefined. This function circumvents that without needing to change the field contents. */
export function preparePreferenceTaskListAttributes(attributes: Attribute[]) {
    return attributes.filter((x) => !!x);
}

export function isApplePlatform() {
    return /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);
}
